import { sha256, sha224 } from 'js-sha256'

export const getIntercomHashFromUser = (user_email) => {
    return sha256.hmac('xVVKXOAB-8_kiQNOJ-6OqY-7YiAAfvY8D2v0VAm4', user_email)
}
